import React, { FunctionComponent } from 'react';
import { createRoot } from 'react-dom/client';

type ComponentMap = Record<string, FunctionComponent<any>>;

export const autoMount = (components: ComponentMap) => {
  Object.entries(components).forEach(([name, Component]) => {
    // TODO: 特集ページのReact化ができるまでの暫定対処
    // const element = document.getElementById(name.toLowerCase());
    // if (element) {
    //   // data-propsをPropsとして扱う
    //   const props = element.dataset.props ? JSON.parse(element.dataset.props) : {};
    //   const rootElement = createRoot(element);
    //   rootElement.render(<Component {...props} />);
    // }
    document.querySelectorAll<HTMLElement>(`#${name.toLowerCase()}`).forEach(element => {
      // data-props属性またはscriptタグからpropsを取得
      let props = {};
      if (element.dataset.props) {
        // 後方互換性のため、data-propsもサポート
        props = JSON.parse(element.dataset.props);
      } else {
        // scriptタグからpropsを取得
        const scriptElement = document.getElementById(`${name.toLowerCase()}-props`);
        if (scriptElement && scriptElement.textContent) {
          props = JSON.parse(scriptElement.textContent);
        }
      }
      const root = createRoot(element);
      root.render(<Component {...props} />);
    });
  });
};
